// define a mixin object
export default {
    data() {
        return {
            showFormSearchHeader: false,
            showSearchResults: false,
        }
    },
    created() {

    },
    mounted() {
        this.$eventBus.$on('showSearchResults', () => {
            this.showSearchResults = true;
        });
    },
    methods: {
        showSearchForm() {
            this.showFormSearchHeader = true;
            $('.block-search').addClass('active');
            $('body').addClass('noscroll');
            $('header .header-right').addClass('hide');
        }
    }
}
